import React from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { NavigationData } from 'core/slices/models';
import './MainContent.scss';

export const NavDataContext = React.createContext<NavigationData | null>(null);

type MainContentProps = {
  loading: boolean;
  error: string | null;
  navData: NavigationData | null;
};
export const MainContent: React.FC<MainContentProps> = ({
  loading,
  error,
  navData,
}) => {
  return (
    <div className="main-container-body">
      <Container fluid>
        <div className="report-container">
          {loading && <div>Loading...</div>}
          {error && <div style={{ color: 'red' }}>{error}</div>}
          {/* <Outlet /> */}
          <NavDataContext.Provider value={navData}>
            <Outlet />
          </NavDataContext.Provider>
        </div>
      </Container>
    </div>
  );
};
